function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h32v32H0z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M22.533 9H9.501a.5.5 0 00-.446.726l3.297 6.524-3.298 6.524a.5.5 0 00.447.726h13.032a.5.5 0 00.446-.726l-3.297-6.524 3.298-6.524A.5.5 0 0022.533 9z",
  fill: "#FCB243"
});

var SvgIconBowActive = function SvgIconBowActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none"
  }, props), _ref, _ref2);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjMyIiBoZWlnaHQ9IjMyIiBmaWxsPSJibGFjayIgZmlsbC1vcGFjaXR5PSIwIi8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMjIuNTMzNCA5SDkuNTAxMTJDOS4yNTc5NiA5IDkuMDcwNDYgOS4xNjcyNCA5LjAxNjI2IDkuMzc1ODVDOC45ODc0NSA5LjQ4NzA2IDguOTk2MjQgOS42MDk5OSA5LjA1NDg0IDkuNzI1NTlMMTIuMzUyMiAxNi4yNDk1TDkuMDU0MzUgMjIuNzc0NEM4Ljg4NjM4IDIzLjEwNzEgOS4xMjgwOCAyMy41IDkuNTAwNjQgMjMuNUgxNi4wMTcySDIyLjUzMjlDMjIuOTA1NCAyMy41IDIzLjE0NzEgMjMuMTA3MSAyMi45NzkyIDIyLjc3NDRMMTkuNjgxOCAxNi4yNTA1TDIyLjk3OTYgOS43MjU1OUMyMy4xNDc2IDkuMzkyOTQgMjIuOTA1OSA5IDIyLjUzMzQgOVoiIGZpbGw9IiNGQ0IyNDMiLz4KPC9zdmc+Cg==";
export { SvgIconBowActive as ReactComponent };